import { HttpClient } from '@wix/http-client';
import _ from 'lodash';

import { PromptHubAcceptedUrls } from '../../chatController/sgChat/constants';
import {
  AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
  SG_FEATURE_NAME,
} from '../../consts';
import { fetchTextOnImageBySectionAndFlow } from '../../utils/fetchDataUtils';
import {
  TextOnImageGetFlowParams,
  TEXT_ON_IMAGE_FLOWS,
  TEXT_ON_IMAGE_BRIGHTNESS,
  TextOnImagePhotosDefinition,
} from '../types';
import { SELECT_FLOW_PROMPT_ID } from './consts';
import {
  getImagesByBrightness,
  getImagesBySectionId,
  reportTextOnImageError,
} from './utils';

export const getTextOnImageFlowPromptHub = async (
  httpClient: HttpClient,
  params: TextOnImageGetFlowParams,
): Promise<{
  flow: TEXT_ON_IMAGE_FLOWS;
  brightness: TEXT_ON_IMAGE_BRIGHTNESS;
}> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_URL,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptId: SELECT_FLOW_PROMPT_ID,
        params,
        userRequestInfo: {
          featureName: SG_FEATURE_NAME,
        },
      },
    );
    const { flow, brightness } = JSON.parse(data.response.generatedTexts[0]);
    return { flow, brightness };
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(
      `Failed to get text on image flow: ${errorResponse}`,
    );
    return {
      flow: TEXT_ON_IMAGE_FLOWS.SKY,
      brightness: TEXT_ON_IMAGE_BRIGHTNESS.BRIGHT,
    };
  }
};

export const getRandomTemplateImageBySectionAndFlow = async (
  sectionName: string,
  flow: TEXT_ON_IMAGE_FLOWS,
  sectionId?: string,
  brightness?: TEXT_ON_IMAGE_BRIGHTNESS,
): Promise<TextOnImagePhotosDefinition | undefined> => {
  try {
    const textOnImageData = await fetchTextOnImageBySectionAndFlow(
      sectionName,
      flow,
    );
    let textOnImageImages: TextOnImagePhotosDefinition[] = [];
    if (flow === TEXT_ON_IMAGE_FLOWS.DATA_VISUALIZATION) {
      textOnImageImages = getImagesByBrightness(
        brightness,
        textOnImageData?.images,
      );
    } else {
      textOnImageImages = getImagesBySectionId(
        sectionId,
        textOnImageData?.images,
      );
    }

    if (textOnImageImages.length === 0) {
      throw new Error('No images found for the given section and flow');
    }

    const randomIndex = _.random(0, textOnImageImages.length - 1);
    const randomImageData = textOnImageImages[randomIndex];

    if (!randomImageData?.url) {
      throw new Error('No random image URL');
    }

    return randomImageData;
  } catch (error: any) {
    reportTextOnImageError(
      `Failed to get template image for section "${sectionName}" and flow "${flow}": ${error}`,
    );
  }
};
